$(function(){
  var categories = ['NEWS', 'INTERVIEW', 'DESIGN', 'ENGINEERING', 'CAREER', 'COLUMN', 'RECRUIT'];
  var headline = $('h3.archive-category');
  var displayingCat = $('h3.archive-category').text();

  if (categories[0] === displayingCat) {
    $(headline).find('span').text('ニュースリリース');
  } else if (categories[1] === displayingCat) {
    $(headline).find('span').text('インタビュー');
  } else if (categories[2] === displayingCat) {
    $(headline).find('span').text('デザイン');
  } else if (categories[3] === displayingCat) {
    $(headline).find('span').text('エンジニアリング');
  } else if (categories[4] === displayingCat) {
    $(headline).find('span').text('キャリア形成');
  } else if (categories[5] === displayingCat) {
    $(headline).find('span').text('コラム');
  } else if (categories[6] === displayingCat) {
    $(headline).find('span').text('採用');
  }
  
});
